import { useStore } from 'effector-react';
import { CSSProperties } from 'react';
import { $columnWidthsStore } from './store/columns';

/** получаем стили в для ряда в соответствии с значениями в конфиге колонок */
export const useRowWidthStyles = () => {
  const columnWidthsStore = useStore($columnWidthsStore);
  const gridTemplateColumns = Array.from(columnWidthsStore).reduce((style, [, value]) => {
    // minWidth/maxWidth - значения заданные в параметрах таблица
    // min/max - значения по умолчанию (зависят от типа колонки)
    style += `minmax(${value.minWidth ?? value.min}, ${value.maxWidth ?? value.max})`;
    return style;
  }, '');

  const widthStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns,
  };
  return widthStyle;
};
